import React from 'react';
import classNames from 'classnames';
import styles from './HeaderWithLogo.module.scss';

const HeaderWithLogo = ({ type, logo, title, subtitle }) => {
  const classes = classNames({
    [styles.HeaderWithLogo]: true,
    [styles[type]]: !!type
  });

  return (
    <div className={ classes }>
      { logo && <img src={ logo } height="80" />}
      <div className={ styles.headers }>
        <h1 className={ styles.title }>{ title }</h1>
        { subtitle && <h4>{ subtitle }</h4>}
      </div>
    </div>
  );
};
 
export default HeaderWithLogo;
